import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {InssPipe} from '../../../pipes/inss.pipe';

@Component({
    selector: 'myabvv-personal-information-identification',
    templateUrl: './personal-information-identification.component.html',
    styles: [],
    standalone: true,
    imports: [TranslateModule, InssPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalInformationIdentificationComponent implements OnInit {
  @Input() inss: string;
  @Input() nationality: string;
  @Input() motherLanguage: string;
  @Input() gender: string;
  @Input() maritalStatus: string;
  @Input() firstName: string;
  @Input() lastName: string;

  constructor() { }

  ngOnInit() {
  }
}
